import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Redirect } from 'react-router-dom'

import Settings from '@/stores/models/settings'
import ExamHomePage from './ExamHomePage'
import ExamPage from './ExamPage'

@inject('contentStore', 'uiStore')
@observer
export default class ExamPageWrapper extends Component {
  componentDidMount() {
    const { uiStore } = this.props
    uiStore.updateTitle('Exam Page')
  }
  render() {
    const { contentStore } = this.props
    const { courseProgress, settings } = contentStore
    const {
      exam: hasExamSetting,
      examOnly,
      examOnlyRedirect,
      examPracticeMode,
      examUnlock,
    } = settings || {}

    // Allow access if exam is enabled and either:
    // 1. Course is 100% complete, OR
    // 2. EXAM_ONLY and EXAM_ONLY_REDIRECT_ON_START are enabled (bypass progress check)
    // 3. EXAM_UNLOCK is enabled
    const hasAccess =
      hasExamSetting &&
      (courseProgress === 100 ||
        (examOnly &&
          examOnlyRedirect === Settings.EXAM_ONLY_REDIRECT_SETTING_ON_START) ||
        examUnlock)
    if (!hasAccess) return <Redirect to="/dashboard" />
    return examPracticeMode ? <ExamHomePage /> : <ExamPage />
  }
}
